import script from "./TransactionTables.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionTables.vue?vue&type=script&lang=ts&setup=true"

import "../Index.scss?vue&type=style&index=0&id=b699fa6a&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b699fa6a"]])

export default __exports__